import gql from 'graphql-tag';
import actionTypes from './constants';

export const dummy = () => {};
/* */
export const getGroupLessons = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_GROUP_LESSONS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.groupLessons);

/* */
export const getLesson = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_LESSON}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.lesson);

/* */
export const getLessonRegistrations = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_LESSON_REGISTRATIONS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.lessonRegistrations);

/* */
export const getCoachs = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_COACHS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.coachs && data.coachs.items || []);

/* */
export const getCoachAvailabilityTimes = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_COACH_AVAILABILITY_TIMES}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.coachAvailableTimes || []);

  /* */
  export const getSkillLevels = (client, variables, fetchPolicy = 'no-cache') => client.query({
    query: gql`${actionTypes.gql.GET_SKILL_LEVELS}`,
    fetchPolicy,
    variables,
  })
    .then((res) => res.data)
    .then((data) => data.skillLevels && data.skillLevels.items || []);

/* */
export const getCustomerFromPGB = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_CUSTOMERS_FROM_PGB}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.customersFromPgb || []);

/* */
export const getMyLessonRegistrations = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_MY_LESSON_REGISTRATIONS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.myLessonRegistrations || []);

/* */
export const getMyLessonPartners = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_MY_LESSON_PARTNERS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.myLessonPartners || []);

/* */
export const getLessonRegistrationsQuota = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.LESSON_REGISTRATION_QUOTAS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => data.lessonRegistrationQuota || {});

/* */
export const groupLessonBook = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.GROUP_LESSON_BOOK}`,
  variables,
})
.then((res) => res.data)
.then((data) => data.groupLessonBook && data.groupLessonBook.lesson || []);

/* */
export const individualLessonBook = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.INDIVIDUAL_LESSON_BOOK}`,
  variables,
})
.then((res) => res.data)
.then((data) => data.individualLessonBook && data.individualLessonBook.lesson || []);

/* */
export const individualLessonCancel = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.INDIVIDUAL_LESSON_CANCEL}`,
  variables,
})
.then((res) => res.data)
.then((data) => data.individualLessonCancel || false);

/* */
export const lessonRegistrationBatchCancel = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.LESSON_REGISTRATION_BATCH_CANCEL}`,
  variables,
})
.then((res) => res.data)
.then((data) => data.lessonRegistrationBatchCancel || false);
